import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-badge px-2.5 py-0.5 font-ui text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-sky focus:ring-offset-2 focus:ring-offset-surface',
  {
    variants: {
      variant: {
        default: 'bg-brand-royal text-brand-ice',
        win: 'bg-win text-white',
        gold: 'bg-gold text-surface',
        loss: 'bg-loss text-white',
        pending: 'bg-amber-500 text-surface',
        outline: 'border border-brand-royal text-brand-ice',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
